export default {"src":"/_next/static/media/0xabc56186c2df63c338e04c9c9b9814e27983a5a9.567de922.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};